import {Component, Input, OnInit} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {MenuItem} from 'primeng/primeng';
import {AppComponent} from './app.component';

import { DatosSesionService } from './servicios/datos-sesion.service';
import { MenuService } from './servicios/menu.service';
import { Aplicativo } from './modelado/sar/aplicativo';
import { UnidadAdministrativa } from './modelado/sar/unidad-administrativa';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
    selector: 'app-menu',
    template: `
        <ul app-submenu [item]="app.menuUsuario" root="true" class="ultima-menu ultima-main-menu clearfix" [reset]="reset" visible="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

    @Input() reset: boolean;

    aplicativo: Aplicativo = new Aplicativo();

    

    model: any[];
    nombreCompleto: string;

    

    listaUnidadesAdministrativas: UnidadAdministrativa[] = [];
    unidadSeleccionada: UnidadAdministrativa = new UnidadAdministrativa();

    

    constructor(public app: AppComponent
    , private _menuServicio: MenuService
    , private _datosSession: DatosSesionService
    ) {}

    ngOnInit() {
        this.aplicativo.nombre = 'NUEVEO SGA';
        this.aplicativo.idAplicativo = '0485d5d2f04e4aaaae9228866c7cc8e0';

        console.log('ingresa informaicon---->');
        
        

        this.model = [
            {
                label: 'Menu Hierarchy', icon: 'menu',
                items: [
                    {
                        label: 'Submenu 1', icon: 'subject',
                        items: [
                            {
                                label: 'Submenu 1.1', icon: 'subject',
                                items: [
                                    {label: 'Submenu 1.1.1', icon: 'subject'},
                                    {label: 'Submenu 1.1.2', icon: 'subject'},
                                    {label: 'Submenu 1.1.3', icon: 'subject'},
                                ]
                            },
                            {
                                label: 'Submenu 1.2', icon: 'subject',
                                items: [
                                    {label: 'Submenu 1.2.1', icon: 'subject'},
                                    {label: 'Submenu 1.2.2', icon: 'subject'}
                                ]
                            },
                        ]
                    },
                    {
                        label: 'Submenu 2', icon: 'subject',
                        items: [
                            {
                                label: 'Submenu 2.1', icon: 'subject',
                                items: [
                                    {label: 'Submenu 2.1.1', icon: 'subject'},
                                    {label: 'Submenu 2.1.2', icon: 'subject'},
                                    {label: 'Submenu 2.1.3', icon: 'subject'},
                                ]
                            },
                            {
                                label: 'Submenu 2.2', icon: 'subject',
                                items: [
                                    {label: 'Submenu 2.2.1', icon: 'subject'},
                                    {label: 'Submenu 2.2.2', icon: 'subject'}
                                ]
                            },
                        ]
                    }
                ]
            }
        ];

        console.log(this.model);

        console.log('===========================================CARGA MENU POR PRIMERA VEZ ==========================================================');
        
        this.nombreCompleto = this._datosSession.getUsuario().nombre;
        this.listaUnidadesAdministrativas = this._datosSession.getUnidadesAdministrativasUusuairo();
        console.log("$$$$$$$$$$$$$$$$ "+this._datosSession.unidadSeleccionadaAplicativo.nombre);

        
        this._datosSession.idPlanificacionActual=this._datosSession.getPlanificacionActual(); 
        this._datosSession.guardarIdPlanificacionActual(this._datosSession.idPlanificacionActual);

        this._datosSession.idDisponibilidadPlanificacion=this._datosSession.getDisponibilidadPlanificacion();
        this._datosSession.guardarIdDisponibilidadPlanificacion(this._datosSession.idDisponibilidadPlanificacion);

        this._datosSession.nombrePlanificacionActual= this._datosSession.getNombrePlanificacionActual();
        this._datosSession.guardarNombrePlanificacionActual(this._datosSession.nombrePlanificacionActual);

        this._datosSession.fechaCreacionPlanificacion=this._datosSession.getFechaCreacionPlanificacion();
        this._datosSession.guardarFechaCreacionPlanificacion(this._datosSession.fechaCreacionPlanificacion);

        this._datosSession.numeroMesPlanificacion=this._datosSession.getNumeroMesPlanificacion();
        this._datosSession.guardarNumeroMesPlanificacion(this._datosSession.numeroMesPlanificacion);

        this._datosSession.tipoVistaActual=this._datosSession.getTipoVistaActual();
        this._datosSession.guardarTipoVistaActual(this._datosSession.tipoVistaActual);
            
        this.cargarMenusUsuarioRolUnidad(this._datosSession.getUnidadSeleccionada());
        this._datosSession.guardarUnidad(this._datosSession.getUnidadSeleccionada());

        //this.model = this._datosSession.menuUsuario ;
        

        // this._menuServicio.listarTodoMenusPorAplicativoMenuItem(this.aplicativo.nombre).then(
        //     (resp: any) => {
      
        //       //this.menusNodo = respuesta.children;
        //       console.log(' UUUUUUUUUUUUUUUUU ' + JSON.stringify(resp));
        //       this.model = resp.items;


        //       console.log( ' el dos  ' + this.model);
      
        //     }
        //   ).catch(error => console.error('ERROR en la promes ', error));
          


        
    }


    /**
     * Permite cambiar los menus del usuario
     * @param idUnidad 
     */
    cargarMenusUsuarioRolUnidad(idUnidad: number){

        this._menuServicio.consultaMenusPorAplicativoPorUsuarioPorUnidad(this._datosSession.getAplicativo().idAplicativo, this._datosSession.getUsuario().idUsuario,idUnidad ).then(
            (resp: any) => {
              // this.model = resp.items;
              this._datosSession.menuUsuario = resp.items;
              // this.model = this._datosSession.menuUsuario ;
              this.app.menuUsuario = this._datosSession.menuUsuario ;
            }
          ).catch(error => console.error('ERROR en cargarMenusUsuarioRolUnidad  Detalle:...', error));

    }

    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('theme-css');
        const layoutLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('layout-css');

        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
    }
}


@Component({  
    selector: '[app-submenu]',
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],  
    templateUrl: './app.menu.componet.html',

    
})
export class AppSubMenuComponent {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(public app: AppComponent) {}

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        // execute command
        if (item.command) {
            item.command({originalEvent: event, item: item});
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true; } else {
                this.app.resetMenu = false; }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }
}
